import React from "react";
import Typography from "@material-ui/core/Typography";
import DataLoadView from "components/admin/DataLoadView";
import { UOM_CATALOG } from "constant/route/admin";

const TABLE_COLUMNS = [
  { title: "Nombre", field: "name", required: true },
  { title: "Abreviatura", field: "abbreviation", required: true },
  { title: "Descripción", field: "description" },
];

function UOMDataLoadView() {
  return (
    <DataLoadView
      appbarTitle="Unidades de Medida - Carga Manual"
      sectionTitle="Carga de Unidades de Medida por archivo"
      goBackTo={UOM_CATALOG}
      description={
        <>
          <Typography paragraph>
            En este apartado puede realizar la carga de unidades de medida
            mediante un archivo en formato CSV.
          </Typography>
          <Typography paragraph>
            Cargue un archivo con el formato especificado y revise los registros
            ingresados. Puede modificar los registros cargados en caso de ser
            necesario. Una vez revisados los datos puede confirmar su ingreso al
            sistema.
          </Typography>
        </>
      }
      templatePath="tmp/templates/uoms_template_es.csv"
      templateName="uoms_template.csv"
      job="UOM"
      dataLoadPrefix="uom"
      tableColumns={TABLE_COLUMNS}
    />
  );
}

export default UOMDataLoadView;
